import React, { useState } from "react";
import "../css/Header4.css";

const Header4 = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* FLOATING FUNKY HEADER */}
      <header className="header4-container">

        {/* LOGO */}
        <div className="header4-logo">SHANK</div>

        {/* NAVIGATION (DESKTOP) */}
        <nav className="header4-nav">
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/workouts">Workout</a>
          <a href="/gallery">Gallery</a>
          <a href="/services">Services</a>
          <a href="/plans">Pricing</a>
          <a href="/trainers">Trainers</a>
          <a href="/faqs">FAQs</a>
        </nav>

        {/* CTA BUTTON */}
        <a href="/contact" className="header4-btn">Contact</a>

        {/* HAMBURGER */}
        <div
          className={`header4-ham ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span><span></span><span></span>
        </div>
      </header>

      {/* FULLSCREEN MOBILE MENU */}
      <div className={`header4-mobile ${menuOpen ? "show" : ""}`}>
        <div className="mobile-inner">

          <div className="mobile-top">
            <div className="mobile-logo">SHANK</div>

            <div className="mobile-close" onClick={() => setMenuOpen(false)}>
              ✕
            </div>
          </div>

          <div className="mobile-links">
            <a href="/" onClick={() => setMenuOpen(false)}>Home</a>
            <a href="/about" onClick={() => setMenuOpen(false)}>About</a>
            <a href="/workouts" onClick={() => setMenuOpen(false)}>Workout</a>
            <a href="/gallery" onClick={() => setMenuOpen(false)}>Gallery</a>
            <a href="/services" onClick={() => setMenuOpen(false)}>Services</a>
            <a href="/plans" onClick={() => setMenuOpen(false)}>Pricing</a>
            <a href="/trainers" onClick={() => setMenuOpen(false)}>Trainers</a>
            <a href="/faqs" onClick={() => setMenuOpen(false)}>FAQs</a>
            <a href="/contact" onClick={() => setMenuOpen(false)}>Contact</a>
          </div>

        </div>
      </div>
    </>
  );
};

export default Header4;
